// Styles
import './certilogo.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSampleStructure = (context) => {
  const certilogoSection = context.closest('.shopify-section');

  const button = certilogoSection.querySelector('#check');
  const error = certilogoSection.querySelector('.error');
  const input = certilogoSection.querySelector('#clgCode');

  button.addEventListener('click', function () {
      var clgCode= certilogoSection.querySelector('#clgCode').value;
      if (/^[0-9]{12}$/.test(clgCode)) { // CLG Code should be 12 digits
          error.innerText = '';
          window.open('http://www.certilogo.com/check/' + clgCode);
      } else {
          error.innerText = 'CLG Code should be 12 digits';
      }
  });
  input.addEventListener('keyup', function () {
    if (this.value.length == 12) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  });
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.certilogo__container'), (el) => {
    window.dAgency.initSampleStructure(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.certilogo__container'), (el) => {
      window.dAgency.initSampleStructure(el);
    });
  });
}
